import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "vault_token";

const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

function errMsg(e) {
  return e?.response?.data?.detail || e?.message || "Something went wrong.";
}

// ---------- Auth ----------
export async function apiLogin(email, password) {
  try {
    const { data } = await http.post("/auth/login", { email, password });
    setToken(data.token);
    return { user: data.user };
  } catch (e) {
    return { error: errMsg(e) };
  }
}

export async function apiRegister(payload) {
  try {
    const { data } = await http.post("/auth/register", payload);
    if (data.pending) {
      return { pending: true, message: data.message };
    }
    setToken(data.token);
    return { user: data.user };
  } catch (e) {
    return { error: errMsg(e) };
  }
}

export async function apiMe() {
  try {
    const { data } = await http.get("/auth/me");
    return data;
  } catch (e) {
    return null;
  }
}

export function apiLogout() {
  setToken(null);
}

// ---------- Users ----------
export const getUsers = () => http.get("/users").then((r) => r.data);
export const updateMe = (firstName, lastName) => http.patch("/users/me", { firstName, lastName }).then((r) => r.data);
export const changePassword = (currentPassword, newPassword) => http.post("/auth/change-password", { currentPassword, newPassword }).then((r) => r.data);
export const awardGems = (targetId, amount, reason) => http.post(`/users/${targetId}/award-gems`, { amount, reason }).then((r) => r.data);
export const adminUpdateUser = (targetId, payload) => http.patch(`/users/${targetId}`, payload).then((r) => r.data);
export const deleteUser = (targetId) => http.delete(`/users/${targetId}`).then((r) => r.data);
export const createUser = (payload) => http.post("/users", payload).then((r) => r.data);
export const removeDemoUsers = () => http.post("/admin/remove-demo-users").then((r) => r.data);

// ---------- Requests ----------
export const getRequests = () => http.get("/requests").then((r) => r.data);
export const createRequest = (payload) => http.post("/requests", payload).then((r) => r.data);
export const getRequest = (id) => http.get(`/requests/${id}`).then((r) => r.data);
export const transitionRequest = (id, newStatus, notes) => http.post(`/requests/${id}/transition`, { newStatus, notes }).then((r) => r.data);

// ---------- Gems ----------
export const getGems = () => http.get("/gems").then((r) => r.data);

// ---------- Notifications ----------
export const getNotifications = () => http.get("/notifications").then((r) => r.data);
export const markNotifRead = (id) => http.post(`/notifications/${id}/read`).then((r) => r.data);
export const markAllRead = () => http.post("/notifications/read-all").then((r) => r.data);

// ---------- Reports / Settings ----------
export const getReports = () => http.get("/reports").then((r) => r.data);
export const getSettings = () => http.get("/settings").then((r) => r.data);
export const putSettings = (payload) => http.put("/settings", payload).then((r) => r.data);

export default http;
